var map = {
	"./images/analyticsCard/effectiveness-green.svg": 89886,
	"./images/analyticsCard/effectiveness-grey.svg": 24188,
	"./images/analyticsCard/medals-green.svg": 74648,
	"./images/analyticsCard/medals-grey.svg": 93078,
	"./images/analyticsCard/percentages-green.svg": 58679,
	"./images/analyticsCard/percentages-grey.svg": 17183,
	"./images/analyticsCard/retakes-green.svg": 43905,
	"./images/analyticsCard/retakes-grey.svg": 68537,
	"./images/analyticsCard/scores-green.svg": 55965,
	"./images/analyticsCard/scores-grey.svg": 35405,
	"./images/analyticsCard/students-green.svg": 90352,
	"./images/analyticsCard/students-grey.svg": 69566,
	"./images/buttons/button-circle-plus.svg": 45459,
	"./images/buttons/button-delete-circle.svg": 4920,
	"./images/flags/ae.svg": 3873,
	"./images/flags/af.svg": 98834,
	"./images/flags/ag.svg": 2147,
	"./images/flags/ai.svg": 66741,
	"./images/flags/al.svg": 90920,
	"./images/flags/am.svg": 86937,
	"./images/flags/and.svg": 37018,
	"./images/flags/ao.svg": 6459,
	"./images/flags/aq.svg": 74797,
	"./images/flags/ar.svg": 91822,
	"./images/flags/as.svg": 6463,
	"./images/flags/at.svg": 88992,
	"./images/flags/au.svg": 3377,
	"./images/flags/aw.svg": 50003,
	"./images/flags/ax.svg": 86724,
	"./images/flags/az.svg": 35846,
	"./images/flags/ba.svg": 90276,
	"./images/flags/bb.svg": 94871,
	"./images/flags/bd.svg": 75305,
	"./images/flags/be.svg": 99800,
	"./images/flags/bf.svg": 38635,
	"./images/flags/bg.svg": 33370,
	"./images/flags/bh.svg": 59117,
	"./images/flags/bi.svg": 23660,
	"./images/flags/bj.svg": 2687,
	"./images/flags/bl.svg": 30225,
	"./images/flags/bm.svg": 89664,
	"./images/flags/bn.svg": 80403,
	"./images/flags/bo.svg": 49826,
	"./images/flags/br.svg": 89543,
	"./images/flags/bs.svg": 50006,
	"./images/flags/bt.svg": 33689,
	"./images/flags/bw.svg": 91338,
	"./images/flags/by.svg": 47420,
	"./images/flags/bz.svg": 10095,
	"./images/flags/ca.svg": 91099,
	"./images/flags/cc.svg": 5753,
	"./images/flags/cd.svg": 65718,
	"./images/flags/cf.svg": 64980,
	"./images/flags/cg.svg": 37589,
	"./images/flags/ch.svg": 83474,
	"./images/flags/ci.svg": 98115,
	"./images/flags/ck.svg": 76609,
	"./images/flags/cl.svg": 63230,
	"./images/flags/cm.svg": 6959,
	"./images/flags/cn.svg": 27932,
	"./images/flags/co.svg": 17405,
	"./images/flags/cr.svg": 45688,
	"./images/flags/cu.svg": 34871,
	"./images/flags/cv.svg": 91748,
	"./images/flags/cx.svg": 98274,
	"./images/flags/cy.svg": 3443,
	"./images/flags/cz.svg": 82688,
	"./images/flags/de.svg": 7254,
	"./images/flags/dj.svg": 64673,
	"./images/flags/dk.svg": 66224,
	"./images/flags/dm.svg": 4766,
	"./images/flags/do.svg": 4668,
	"./images/flags/dz.svg": 87473,
	"./images/flags/ec.svg": 48299,
	"./images/flags/ee.svg": 77957,
	"./images/flags/eg.svg": 4535,
	"./images/flags/er.svg": 1002,
	"./images/flags/es.svg": 42971,
	"./images/flags/et.svg": 27700,
	"./images/flags/fi.svg": 48664,
	"./images/flags/fj.svg": 6731,
	"./images/flags/fk.svg": 12858,
	"./images/flags/fm.svg": 39140,
	"./images/flags/fo.svg": 88262,
	"./images/flags/fr.svg": 54563,
	"./images/flags/ga.svg": 71383,
	"./images/flags/gb.svg": 28260,
	"./images/flags/gd.svg": 87706,
	"./images/flags/ge.svg": 90411,
	"./images/flags/gf.svg": 51576,
	"./images/flags/gg.svg": 86441,
	"./images/flags/gh.svg": 49710,
	"./images/flags/gi.svg": 54463,
	"./images/flags/gl.svg": 4162,
	"./images/flags/gm.svg": 66803,
	"./images/flags/gn.svg": 12256,
	"./images/flags/gp.svg": 36406,
	"./images/flags/gq.svg": 23527,
	"./images/flags/gr.svg": 52020,
	"./images/flags/gs.svg": 77653,
	"./images/flags/gt.svg": 67242,
	"./images/flags/gu.svg": 85083,
	"./images/flags/gw.svg": 27993,
	"./images/flags/gy.svg": 12847,
	"./images/flags/hk.svg": 37100,
	"./images/flags/hn.svg": 13041,
	"./images/flags/hr.svg": 76405,
	"./images/flags/ht.svg": 16123,
	"./images/flags/hu.svg": 47306,
	"./images/flags/id.svg": 60968,
	"./images/flags/ie.svg": 68889,
	"./images/flags/il.svg": 4208,
	"./images/flags/im.svg": 16449,
	"./images/flags/in.svg": 11410,
	"./images/flags/io.svg": 65699,
	"./images/flags/iq.svg": 40229,
	"./images/flags/ir.svg": 41094,
	"./images/flags/is.svg": 28631,
	"./images/flags/it.svg": 8824,
	"./images/flags/je.svg": 50736,
	"./images/flags/jm.svg": 50024,
	"./images/flags/jo.svg": 40394,
	"./images/flags/jp.svg": 78157,
	"./images/flags/ke.svg": 10655,
	"./images/flags/kg.svg": 30573,
	"./images/flags/kh.svg": 43898,
	"./images/flags/ki.svg": 58507,
	"./images/flags/km.svg": 96951,
	"./images/flags/kn.svg": 53828,
	"./images/flags/kp.svg": 45554,
	"./images/flags/kr.svg": 3152,
	"./images/flags/kw.svg": 79485,
	"./images/flags/ky.svg": 53179,
	"./images/flags/kz.svg": 2440,
	"./images/flags/la.svg": 69154,
	"./images/flags/lb.svg": 49553,
	"./images/flags/lc.svg": 8992,
	"./images/flags/li.svg": 52698,
	"./images/flags/lk.svg": 19128,
	"./images/flags/lr.svg": 26753,
	"./images/flags/ls.svg": 28304,
	"./images/flags/lt.svg": 29423,
	"./images/flags/lu.svg": 66846,
	"./images/flags/lv.svg": 78941,
	"./images/flags/ly.svg": 10666,
	"./images/flags/ma.svg": 95937,
	"./images/flags/mc.svg": 17443,
	"./images/flags/md.svg": 47260,
	"./images/flags/me.svg": 36733,
	"./images/flags/mf.svg": 82558,
	"./images/flags/mg.svg": 26287,
	"./images/flags/mh.svg": 59688,
	"./images/flags/mk.svg": 10427,
	"./images/flags/ml.svg": 84308,
	"./images/flags/mm.svg": 56917,
	"./images/flags/mn.svg": 85046,
	"./images/flags/mo.svg": 48871,
	"./images/flags/mp.svg": 2016,
	"./images/flags/mq.svg": 37969,
	"./images/flags/mr.svg": 17602,
	"./images/flags/ms.svg": 22771,
	"./images/flags/mt.svg": 88876,
	"./images/flags/mu.svg": 87821,
	"./images/flags/mv.svg": 39470,
	"./images/flags/mw.svg": 67903,
	"./images/flags/mx.svg": 65016,
	"./images/flags/my.svg": 69257,
	"./images/flags/mz.svg": 1146,
	"./images/flags/na.svg": 61240,
	"./images/flags/nc.svg": 97370,
	"./images/flags/ne.svg": 37924,
	"./images/flags/nf.svg": 81047,
	"./images/flags/ng.svg": 93510,
	"./images/flags/ni.svg": 21920,
	"./images/flags/nl.svg": 88493,
	"./images/flags/no.svg": 59374,
	"./images/flags/np.svg": 37657,
	"./images/flags/nr.svg": 94747,
	"./images/flags/nu.svg": 61684,
	"./images/flags/nz.svg": 18115,
	"./images/flags/om.svg": 219,
	"./images/flags/pa.svg": 17182,
	"./images/flags/pe.svg": 21074,
	"./images/flags/pf.svg": 26113,
	"./images/flags/pg.svg": 13872,
	"./images/flags/ph.svg": 90439,
	"./images/flags/pk.svg": 18932,
	"./images/flags/pl.svg": 51995,
	"./images/flags/pm.svg": 34154,
	"./images/flags/pn.svg": 78553,
	"./images/flags/pr.svg": 29389,
	"./images/flags/ps.svg": 49676,
	"./images/flags/pt.svg": 33715,
	"./images/flags/pw.svg": 79168,
	"./images/flags/py.svg": 50758,
	"./images/flags/qa.svg": 98157,
	"./images/flags/re.svg": 57832,
	"./images/flags/ro.svg": 65746,
	"./images/flags/rs.svg": 2758,
	"./images/flags/ru.svg": 63160,
	"./images/flags/rw.svg": 27354,
	"./images/flags/sa.svg": 73643,
	"./images/flags/sb.svg": 15576,
	"./images/flags/sc.svg": 24585,
	"./images/flags/sd.svg": 55174,
	"./images/flags/se.svg": 60503,
	"./images/flags/sg.svg": 86949,
	"./images/flags/si.svg": 69331,
	"./images/flags/sj.svg": 59374,
	"./images/flags/sk.svg": 22705,
	"./images/flags/sl.svg": 11150,
	"./images/flags/sm.svg": 25791,
	"./images/flags/sn.svg": 46764,
	"./images/flags/so.svg": 94125,
	"./images/flags/sr.svg": 10248,
	"./images/flags/ss.svg": 6265,
	"./images/flags/st.svg": 49430,
	"./images/flags/sv.svg": 48084,
	"./images/flags/sx.svg": 18162,
	"./images/flags/sy.svg": 21475,
	"./images/flags/sz.svg": 32080,
	"./images/flags/tc.svg": 74680,
	"./images/flags/td.svg": 63863,
	"./images/flags/tf.svg": 71909,
	"./images/flags/tg.svg": 20740,
	"./images/flags/th.svg": 32435,
	"./images/flags/tj.svg": 47633,
	"./images/flags/tk.svg": 11680,
	"./images/flags/tl.svg": 77567,
	"./images/flags/tm.svg": 49134,
	"./images/flags/tn.svg": 97485,
	"./images/flags/to.svg": 98540,
	"./images/flags/tr.svg": 34745,
	"./images/flags/tt.svg": 58535,
	"./images/flags/tv.svg": 66581,
	"./images/flags/tw.svg": 93972,
	"./images/flags/tz.svg": 5601,
	"./images/flags/ua.svg": 63513,
	"./images/flags/ug.svg": 69895,
	"./images/flags/us.svg": 30891,
	"./images/flags/uy.svg": 79953,
	"./images/flags/uz.svg": 22850,
	"./images/flags/va.svg": 85552,
	"./images/flags/vc.svg": 2258,
	"./images/flags/ve.svg": 23996,
	"./images/flags/vg.svg": 24094,
	"./images/flags/vi.svg": 28520,
	"./images/flags/vn.svg": 88500,
	"./images/flags/vu.svg": 236,
	"./images/flags/wf.svg": 16936,
	"./images/flags/ws.svg": 19493,
	"./images/flags/xx.svg": 36511,
	"./images/flags/ye.svg": 61545,
	"./images/flags/yt.svg": 38184,
	"./images/flags/za.svg": 56428,
	"./images/flags/zm.svg": 25240,
	"./images/flags/zw.svg": 27826,
	"./images/icons/Info/arrow-up-right.svg": 91039,
	"./images/icons/Info/default-avatar.svg": 66926,
	"./images/icons/Info/nav-courses.svg": 82685,
	"./images/icons/add-image.svg": 51159,
	"./images/icons/alert-triangle.svg": 30285,
	"./images/icons/arrow-left.svg": 39845,
	"./images/icons/arrow-right.svg": 91720,
	"./images/icons/arrow-up-right.svg": 89828,
	"./images/icons/avatar.svg": 22669,
	"./images/icons/book.svg": 58049,
	"./images/icons/check-blue.svg": 12547,
	"./images/icons/check-error.svg": 15303,
	"./images/icons/check-green.svg": 53800,
	"./images/icons/check-square.svg": 79990,
	"./images/icons/check.svg": 53658,
	"./images/icons/chevron-down.svg": 66688,
	"./images/icons/chevrons-down.svg": 45595,
	"./images/icons/chevrons-up.svg": 25876,
	"./images/icons/circle.svg": 57042,
	"./images/icons/clipboard-black.svg": 65778,
	"./images/icons/clipboard.svg": 17848,
	"./images/icons/clock.svg": 95904,
	"./images/icons/copy.svg": 73761,
	"./images/icons/default-logo.svg": 92583,
	"./images/icons/download.svg": 59474,
	"./images/icons/drag.svg": 21403,
	"./images/icons/edit-pen.svg": 22040,
	"./images/icons/edit.svg": 23374,
	"./images/icons/editing-round.svg": 11333,
	"./images/icons/educationMaterials/additionalAudio.svg": 41968,
	"./images/icons/educationMaterials/additionalImage.svg": 83193,
	"./images/icons/educationMaterials/additionalText.svg": 16351,
	"./images/icons/educationMaterials/additionalVideo.svg": 16991,
	"./images/icons/educationMaterials/audio.svg": 89649,
	"./images/icons/educationMaterials/audioActive.svg": 37559,
	"./images/icons/educationMaterials/closed.svg": 93945,
	"./images/icons/educationMaterials/closedSimple.svg": 39027,
	"./images/icons/educationMaterials/exam.svg": 89892,
	"./images/icons/educationMaterials/examActive.svg": 1506,
	"./images/icons/educationMaterials/examGray.svg": 37769,
	"./images/icons/educationMaterials/examSimple.svg": 8930,
	"./images/icons/educationMaterials/examSimpleGreen.svg": 35115,
	"./images/icons/educationMaterials/examSuccess.svg": 80445,
	"./images/icons/educationMaterials/examUnsuccess.svg": 40902,
	"./images/icons/educationMaterials/pdf.svg": 68877,
	"./images/icons/educationMaterials/pdfActive.svg": 35163,
	"./images/icons/educationMaterials/pdfSuccess.svg": 79550,
	"./images/icons/educationMaterials/practice.svg": 24906,
	"./images/icons/educationMaterials/practiceActive.svg": 13960,
	"./images/icons/educationMaterials/practiceGray.svg": 89647,
	"./images/icons/educationMaterials/practiceSimple.svg": 31252,
	"./images/icons/educationMaterials/practiceSimpleGreen.svg": 98253,
	"./images/icons/educationMaterials/practiceSuccess.svg": 34851,
	"./images/icons/educationMaterials/practiceUnsuccess.svg": 60184,
	"./images/icons/educationMaterials/presentation.svg": 80925,
	"./images/icons/educationMaterials/presentationActive.svg": 43723,
	"./images/icons/educationMaterials/presentationSuccess.svg": 85006,
	"./images/icons/educationMaterials/theory.svg": 12398,
	"./images/icons/educationMaterials/theoryActive.svg": 59444,
	"./images/icons/educationMaterials/theoryGray.svg": 67851,
	"./images/icons/educationMaterials/theorySimple.svg": 67296,
	"./images/icons/educationMaterials/theorySimpleGreen.svg": 32241,
	"./images/icons/educationMaterials/theorySuccess.svg": 79855,
	"./images/icons/educationMaterials/video.svg": 10806,
	"./images/icons/educationMaterials/videoActive.svg": 45356,
	"./images/icons/educationMaterials/videoSimple.svg": 20536,
	"./images/icons/educationMaterials/videoSimpleGreen.svg": 92521,
	"./images/icons/educationMaterials/videoSuccess.svg": 71847,
	"./images/icons/eye-off.svg": 12761,
	"./images/icons/eye.svg": 61589,
	"./images/icons/facebook.svg": 52542,
	"./images/icons/file-text.svg": 63048,
	"./images/icons/filters-line.svg": 37778,
	"./images/icons/filters.svg": 28155,
	"./images/icons/google.svg": 15583,
	"./images/icons/hint.svg": 99977,
	"./images/icons/history-restore.svg": 91007,
	"./images/icons/image.svg": 12225,
	"./images/icons/list.svg": 50710,
	"./images/icons/log-out.svg": 62007,
	"./images/icons/magnify.svg": 5611,
	"./images/icons/nav-company-profile.svg": 99103,
	"./images/icons/nav-courses.svg": 81368,
	"./images/icons/nav-create-company.svg": 80532,
	"./images/icons/nav-edit.svg": 24966,
	"./images/icons/nav-edu-programs.svg": 23564,
	"./images/icons/nav-groups.svg": 86634,
	"./images/icons/nav-history.svg": 30906,
	"./images/icons/nav-home.svg": 80467,
	"./images/icons/nav-language.svg": 67572,
	"./images/icons/nav-library.svg": 77123,
	"./images/icons/nav-settings.svg": 30241,
	"./images/icons/nav-support.svg": 64671,
	"./images/icons/nav-technicalSupport.svg": 79540,
	"./images/icons/nav-users.svg": 38378,
	"./images/icons/nav/admin.svg": 54181,
	"./images/icons/nav/log-out.svg": 39477,
	"./images/icons/nav/manager.svg": 33373,
	"./images/icons/nav/owner.svg": 96517,
	"./images/icons/nav/profile.svg": 59375,
	"./images/icons/nav/student.svg": 40849,
	"./images/icons/nav/trainer.svg": 80783,
	"./images/icons/notify/alert-triangle.svg": 77423,
	"./images/icons/notify/checked.svg": 18847,
	"./images/icons/notify/email.svg": 48980,
	"./images/icons/notify/error.svg": 99110,
	"./images/icons/notify/file.svg": 61606,
	"./images/icons/notify/key.svg": 11305,
	"./images/icons/notify/lock.svg": 2449,
	"./images/icons/notify/success.svg": 28197,
	"./images/icons/notify/trash.svg": 34866,
	"./images/icons/notify/unlock.svg": 32728,
	"./images/icons/notify/upload-cloud.svg": 54427,
	"./images/icons/notify/warning-circle.svg": 84125,
	"./images/icons/notify/warning-outline.svg": 68097,
	"./images/icons/notify/warning.svg": 14192,
	"./images/icons/openbook.svg": 88641,
	"./images/icons/passage-alert-octagon.svg": 46593,
	"./images/icons/passage-check-square.svg": 61827,
	"./images/icons/passage-clock.svg": 68059,
	"./images/icons/passage-edit.svg": 3775,
	"./images/icons/percent.svg": 6261,
	"./images/icons/plus-circle.svg": 49611,
	"./images/icons/plus.svg": 68718,
	"./images/icons/programMaterials/closed.svg": 85783,
	"./images/icons/programMaterials/course.svg": 86560,
	"./images/icons/programMaterials/courseActive.svg": 65222,
	"./images/icons/programMaterials/courseSuccess.svg": 61505,
	"./images/icons/programMaterials/webinar.svg": 20515,
	"./images/icons/programMaterials/webinarActive.svg": 63337,
	"./images/icons/programMaterials/webinarSuccess.svg": 37276,
	"./images/icons/select-cards.svg": 57296,
	"./images/icons/select.svg": 66162,
	"./images/icons/shuffle.svg": 77669,
	"./images/icons/square.svg": 31927,
	"./images/icons/table-blocked.svg": 28969,
	"./images/icons/table-certificate.svg": 65848,
	"./images/icons/table-delete-user.svg": 2934,
	"./images/icons/table-edit-user.svg": 43053,
	"./images/icons/table-reassign.svg": 54931,
	"./images/icons/table-send-email-user.svg": 57726,
	"./images/icons/table-shield.svg": 20088,
	"./images/icons/table-unblocked.svg": 64930,
	"./images/icons/table-view.svg": 89152,
	"./images/icons/table-viewUser.svg": 63009,
	"./images/icons/test-failed.svg": 86752,
	"./images/icons/test-success.svg": 35940,
	"./images/icons/trash-blue.svg": 82925,
	"./images/icons/trash-gray.svg": 9296,
	"./images/icons/trash.svg": 78196,
	"./images/icons/upload-white.svg": 82549,
	"./images/icons/upload.svg": 51873,
	"./images/icons/user-plus.svg": 20612,
	"./images/icons/users.svg": 10290,
	"./images/icons/webinar-green.svg": 45706,
	"./images/icons/webinar-silver.svg": 7642,
	"./images/icons/webinar-yellow.svg": 99473,
	"./images/logo-dark.svg": 53067,
	"./images/logo.svg": 3914,
	"./images/white-logo.svg": 61958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91980;